var map = {
	"./de.json": "2508",
	"./en.json": "e088",
	"./es.json": "d90a",
	"./fr.json": "2394",
	"./ja.json": "19d0",
	"./ko.json": "4f29",
	"./pt_pt.json": "a736",
	"./zh_cn.json": "6742",
	"./zh_tw.json": "10ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a82";